<!--
 * @Author: wsx
 * @Date: 2022-01-13 14:42:05
 * @LastEditTime: 2022-02-14 16:05:20
 * @LastEditors: Please set LastEditors
 * @Description:tabs-menu 菜单权限管理
-->
<template>
  <div label="功能权限" class="tabs-menu">
    <div class="h-card-box">
      <el-card class="tabs-menu-card">
        <template #header>
          <span>系统菜单</span>
        </template>
        <div class="menu-tree-box">
          <el-tree
            ref="treeRef"
            :data="dataSource"
            node-key="menuId"
            show-checkbox
            highlight-current
            :props="{ label: 'name' }"
            @current-change="currentChange"
          >
          </el-tree>
        </div>
      </el-card>
      <!-- <el-card class="tabs-menu-card">
        <template #header>
          <span>操作按钮</span>
        </template>
        <div class="menu-btn-box">
          <template v-for="item in btnList" :key="item.id">
            <el-checkbox
              v-model="item.value"
              :label="item.label"
              size="large"
            ></el-checkbox>
          </template>
        </div>
      </el-card> -->
    </div>

    <div class="h-btn-box">
      <h-button type="primary" @click="saveRoleMenu">保存</h-button>
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted, reactive, toRefs, watch, ref } from "vue";

import { getRoleInfo, roleUpdate } from "@/api/system/role.js";
import { getMenuList } from "@/api/system/menu.js";
import HButton from "../../../../components/global/HButton.vue";
import { ElMessage } from "element-plus";
import util from "@util/js";
import _ from "lodash";
export default defineComponent({
  name: "TabsMenu",
  components: { HButton },
  props: {
    role: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const state = reactive({
      dataSource: [],
      menuKeys: ["3-2"],
      btnList: [
        {
          id: 1,
          label: "添加",
          value: false
        },
        {
          id: 2,
          label: "删除",
          value: false
        },
        {
          id: 1,
          label: "详情",
          value: false
        }
      ],
      currentNode: {}
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
    };
    // 保存角色菜单权限
    const saveRoleMenu = async () => {
      const form = _.cloneDeep(props.role);
      // const ids = treeRef.value.getCheckedKeys();

      const ids = [].concat(
        treeRef.value.getCheckedKeys(),
        -9999,
        treeRef.value.getHalfCheckedKeys()
      );
      form.menuIdList = ids;
      util.formatForm(form);
      const res = await roleUpdate(form);
      if (res.code === 0) {
        ElMessage.success("操作成功");
      }
    };
    // 获取角色信息
    const getRoleInfoAsync = async roleId => {
      if (roleId) {
        const res = await getRoleInfo(roleId);
        let ids = res.role.menuIdList.indexOf(-9999);
        if (ids != -1) {
          res.role.menuIdList.splice(ids, res.role.menuIdList.length - ids);
        }
        treeRef.value.setCheckedKeys(res.role.menuIdList, false);
        console.log(
          "%c [ roleInfo ]-218",
          "font-size:13px; background:pink; color:#bf2c9f;",
          res
        );
      }
    };

    // 获取结构树
    const getRouterAsync = async () => {
      const res = await getMenuList();
      const list = res.menuList.filter(item => item.type !== 2);
      const options = { pid: "parentId", id: "menuId", rootPid: 0 };
      const treeData = util.arrayToTree(list, options);
      state.dataSource = treeData;
    };
    getRouterAsync();
    let i = 1;
    const setCheckedKeys = () => {
      // 测试选中角色改变菜单勾选项
      i++;
      if (i % 2 === 1) {
        state.menuKeys = ["1"];
      } else {
        state.menuKeys = ["3-2"];
      }
      getRoleInfoAsync(props.role.roleId);
    };
    watch(
      () => props.role,
      () => {
        setCheckedKeys();
      }
    );
    onMounted(() => {
      setCheckedKeys();
    });
    return {
      ...refData,
      treeRef,
      currentChange,
      setCheckedKeys,
      saveRoleMenu
    };
  }
});
</script>
<style lang="scss" scoped>
.tabs-menu {
  width: 100%;
  height: 100%;
  @include flex-col-sb-c;
  .h-btn-box {
    width: 100%;
    margin-top: 10px;
    @include flex-row-c-c;
  }
  .h-card-box {
    flex: 1;
    width: 100%;
    @include flex-row-sb-c;
    overflow: auto;
  }
  .tabs-menu-card {
    height: 100%;
    flex: 1;
    margin: 0 10px;
    .menu-tree-box,
    .menu-btn-box {
      width: 100%;
      height: 100%;
      overflow: auto;
    }
    .menu-btn-box {
      @include flex-col-s-s;
    }
  }
}
</style>
